export default __webpack_public_path__ + "static/media/logo-main.17fe550d.png";